export default (): void => {
  const pathname = window.encodeURIComponent(window.location.pathname)
  const search = window.encodeURIComponent(window.location.search)
  window.location.replace(
    `/auth?pathname=${pathname}${search ? `&search=${search}` : ''}`
  )
}
